<template>
  <div>
    <div v-if="arr && arr.length > 0">
      <div class="multi-str-add-single" v-for="(item, index) in arr">
        <el-input v-model="arr[index]" placeholder="请输入内容" style="width: 90%;"></el-input>
        <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delColumn(index)"></i>
      </div>
    </div>
    <div>
      <el-button type="primary" @click="addOne">增加一列</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XrMultiStrAdd',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      arr: []
    }
  },
  watch: {
    value(newValue) {
      if(newValue == null || newValue == undefined){
        newValue = '';
      }
      try {
        console.log('111');
        console.log(newValue);
        console.log('++++++++++++++++++++++++++++++++++++++');
        this.arr= newValue.split("##thzc##");
      } catch (error) {
        this.arr = [];
      }
    },
    arr: {
      handler() {
        let arr = this.arr;
        console.log('arr:');
        console.log(arr);
        let newValue = '';
        for (let i = 0; i < arr.length; i++) {
          console.log(arr[i]);
          if(newValue == ''){
            newValue = arr[i];
          }else{
            newValue += '##thzc##' + arr[i];
          }
        }

        console.log(newValue);
        console.log('++++++++++++++++++++++++++++++++++++++');
        this.$emit('change', newValue);
      },
      deep: true
    }
  },
  components: {

  },
  methods: {
    //添加一行
    addOne(){
      this.arr.push('');
    },
    //【数据列】删除一行
    delColumn(index){
      this.arr.splice(index,1)
    },
  }
}
</script>
<style scoped>
  .multi-str-add-single{margin-bottom: 10px;}
</style>




// WEBPACK FOOTER //
// src/components/XrMultiStrAdd/index.vue